module.exports = __webpack_public_path__ + "img/intro-3-hover.70c0150d.png";